import { Injectable } from "@angular/core";
import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { PromiseLookupService } from "./PromiseLookupService";
import { IPromiseBlotterLookupService } from "../IPromiseBlotterLookupService";
import { Subject } from "rxjs";
// import { BFXNotificationType } from '../../model/core/BFXNotificationType';
// import { BFXAppNotificationType } from '../../model/core/BFXAppNotificationType';

import { LoggerService } from "@bfx/logger";
import { IOrderEntryEvent } from "shared/cubiq-services/model/core/IOrderEntryEvent";
const logger = LoggerService.for(__dirname);

export abstract class PromiseBlotterLookupService<K, V extends CubiqTS.ConcreteEncodable>
  extends PromiseLookupService<K, V>
  implements IPromiseBlotterLookupService<K, V>
{
  constructor() {
    super();
  }

  abstract getModelDeleteSubject(): Subject<K>;
  abstract getModelDeleteWithReasonSubject(): Subject<K>;
  abstract getModelErrorSubject(): Subject<any>;
  abstract getModelBatchUpdateSubject(): Subject<any>;
  abstract getModelOrderEntrySubject(): Subject<IOrderEntryEvent>;
  abstract getOrderEntryClearEventSubject(): Subject<IOrderEntryEvent>;
  // abstract setNotificationTypes(types:Array<BFXNotificationType>):void;
  // abstract getModelNotificationSubject(): Subject<INotificationEvent>;
  // abstract setAppNotificationTypes(types:Array<BFXAppNotificationType>):void;
  // abstract getModelAppNotificationSubject(): Subject<CubiqTS.ConcreteEncodable>;
  abstract getModelDetailFillSubject(): Subject<any>;
  abstract setDetailFillIds(orderIdRefs: Array<[string, string]>): void;
  abstract startUpdates(): void;
  abstract setExtendedLogging(logState: boolean): void;
}
